import React from "react";
import { Check, Loader2, RotateCcw } from "lucide-react";

import { useLeafFlagSaves, useLeafSaveStatus } from "@/hooks/useLeafFlagSaves";

import { Tip } from "@/components/ui";
import { AREA } from "./leafGrid";
import "./LeafSaveSlot.css";

export const LeafSaveSlot: React.FC<{ path: string; name: string }> = ({
  path,
  name,
}) => {
  const status = useLeafSaveStatus(path);
  const { retry } = useLeafFlagSaves();
  return (
    <div className={`${AREA.slot} flex items-center`}>
      {status === "saving" && (
        <Tip label="Saving">
          <Loader2
            role="img"
            aria-label="Saving"
            className="fade-in h-4 w-4 text-slate-300 motion-safe:animate-spin"
          />
        </Tip>
      )}
      {status === "saved" && (
        <Tip label="Saved">
          <Check
            role="img"
            aria-label="Saved"
            className="leaf-tick h-4 w-4 text-emerald-400"
          />
        </Tip>
      )}
      {status === "failed" && (
        <button
          type="button"
          data-retry
          aria-label={`Not saved. Retry ${name}`}
          onClick={() => retry(path)}
          className="fade-in inline-flex items-center gap-1 rounded-full border border-rose-400/60 bg-rose-50 px-2 py-0.5 text-xs font-medium text-rose-400 transition-transform duration-150 motion-safe:active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-400 dark:bg-rose-950/40"
        >
          <RotateCcw className="h-3 w-3" aria-hidden />
          Retry
        </button>
      )}
    </div>
  );
};
